import React, {useEffect, useCallback} from "react";
import {useEventListener} from "../../../infrastructure/hooks/useEventListener";
import {KEY_CODES} from "../../../core/consts";
import {NEW_SEARCH_WIDGET} from "../new-search-widget.consts";

export const NewSearchWidgetTabClickComposer = (Widget) => ({controller}) => {
  const {device, state} = controller;
  const {isSmallView} = device;
  const {isSearchVisible, isNoSectionActive} = state;

  const onKeyboardClick = useCallback((event) => {
    if (!isSmallView) {
      if (isSearchVisible && event.keyCode === KEY_CODES.tab) {
        event.preventDefault();
        controller.action(NEW_SEARCH_WIDGET.ACTION_TYPES.CLICK.onTabClick, {
          direction: event.shiftKey ? NEW_SEARCH_WIDGET.DIRECTIONS.prev : NEW_SEARCH_WIDGET.DIRECTIONS.next
        })
      }
      if (isNoSectionActive && event.keyCode === KEY_CODES.down) {
        controller.action(NEW_SEARCH_WIDGET.ACTION_TYPES.CLICK.onTabClick, {
          index: NEW_SEARCH_WIDGET.TAB_SECTION.popularAndResults
        })
      }
    }
  });

  useEventListener('keydown', onKeyboardClick);

  useEffect(() => {
    if (!isSearchVisible && !isSmallView) {
      controller.action(NEW_SEARCH_WIDGET.ACTION_TYPES.CLICK.onTabClick, {reset: true})
    }
  }, [isSearchVisible]);

  const newProps = {
    controller,
    isSmallView
  };

  return <Widget {...newProps}/>;
};
